<!--
    @author qixf@thinkerx.com
    @remark 提现申请记录
    @created 2020/5/21
-->
<template>
  <div>
    <!-- 时间筛选 -->
    <el-row style="margin: 15px 0;">
      <el-col :span="24">
        <el-input style="float: right; width: 200px; margin-left: 15px;" v-model="keywords"
                  suffix-icon="el-icon-search" placeholder="提交用户"
                  @change="getList"></el-input>

        <el-date-picker style="float: right; margin-left: 15px;" v-model="date_range" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        value-format="yyyy-MM-dd" @change="getList">
        </el-date-picker>

        <el-select style="float: right" v-model="status" clearable
                   placeholder="请选择状态" @change="getList">
          <el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table border stripe :data="list" style="width: 100%">
      <el-table-column prop="created_at" label="提交时间" width="180"></el-table-column>
      <el-table-column prop="phone_number" label="提交用户" width="140"></el-table-column>
      <el-table-column label="提现方式" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.type==1">{{scope.row.name}}</span>
          <span v-else>银行卡 - {{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="account" label="账号" width="200"></el-table-column>
      <el-table-column prop="account_name" label="户名" width="180"></el-table-column>
      <el-table-column prop="withdraw_money" label="提现金额" width="100"></el-table-column>
      <el-table-column prop="finish_time" label="完成时间" width="180"></el-table-column>
      <el-table-column label="操作" min-width="180" fixed="right">
        <template slot-scope="scope">
          <span v-if="scope.row.status==0">
            <el-button type="success" size="mini" @click="changeStatus(scope.row.id,1,'')">已转账</el-button>
            <el-button type="danger" size="mini" @click="note_dialog={ show:true, note:'', id:scope.row.id }">驳回</el-button>
          </span>
          <span v-else-if="scope.row.status==1">已转账</span>
          <span v-else>驳回
            <el-tooltip :content="scope.row.note" placement="bottom">
              <el-button type="text">查看原因</el-button>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="padding: 15px 0; text-align: right;">
      <el-pagination :hide-on-single-page="true" background
                     @current-change="handleCurrentChange"
                     :current-page="pagination.page"
                     :page-size="pagination.page_size"
                     layout="total, prev, pager, next, jumper"
                     :total="pagination.total">
      </el-pagination>
    </div>
    <div style="height: 100px;"></div>

    <!-- 驳回填写备注 -->
    <el-dialog title="填写驳回原因" width="200"
      :visible.sync="note_dialog.show">
      <el-input type="textarea" :rows="4" placeholder="请输入驳回原因"
        v-model="note_dialog.note"></el-input>
      <span slot="footer">
        <el-button @click="note_dialog.show=false">取消</el-button>
        <el-button type="primary" @click="changeStatus(note_dialog.id,2,note_dialog.note)">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "payment-log",
  data() {
    return {
      date_range: ["",""],
      keywords: '',
      status: 1,
      status_list: [{ value: 1, label: '处理中'}, { value: 2, label: '已转账'}, { value: 3, label: '驳回'}],
      list: [],
      pagination: {
        page: 1, total: 400, page_size: 15
      },
      note_dialog: { show: false, note: '', id: 0 }
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    getList() {
      let params = {
        page: this.pagination.page,
        start_date: this.date_range[0],
        end_date: this.date_range[1],
        keyword: this.keywords, status: this.status
      };
      this.list = [];
      this.$axios.get("withdraw-list", params).then(res => {
        this.list = res.data;
        this.pagination.total = res.total;
      });
    },
    /** 更改提现状态 **/
    changeStatus(id, status, note) {
      if (status==2 && !note) {
        this.$message.error("请输入驳回原因");
        return;
      }
      let params = { id, status, note };
      this.$axios.put("withdraw-list", params).then(res => {
        this.note_dialog.show = false;
        this.getList();
      });
    }
  },
  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss" scoped>
</style>